/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesRosterInvitationStatusSchema = z.enum([
  "Pending",
  "Accepted",
  "Rejected",
  "Expired",
  "Cancelled",
]);
